import { render, staticRenderFns } from "./canvasText.vue?vue&type=template&id=43e5f9e9&scoped=true&"
import script from "./canvasText.vue?vue&type=script&lang=js&"
export * from "./canvasText.vue?vue&type=script&lang=js&"
import style0 from "./canvasText.vue?vue&type=style&index=0&id=43e5f9e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e5f9e9",
  null
  
)

export default component.exports